import React from 'react'
import { withIcon } from '../../withIcon'

function SlideFirstIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M7.5 5H8.5V19H7.5V5Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16.5 18.5793V5.42024C16.5 5.25505 16.4158 5.10438 16.2856 5.03629C16.1564 4.96933 16.0042 4.99611 15.8979 5.10772L9.61414 11.6872C9.46195 11.8457 9.46195 12.1538 9.61414 12.3134L15.8979 18.8918C16.0042 19.0034 16.1564 19.0313 16.2856 18.9632C16.4158 18.8962 16.5 18.7456 16.5 18.5793Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SlideFirstIcon)
